import { render, staticRenderFns } from "./LoginAdmin.vue?vue&type=template&id=824c9bea&scoped=true"
import script from "./LoginAdmin.vue?vue&type=script&lang=js"
export * from "./LoginAdmin.vue?vue&type=script&lang=js"
import style0 from "./LoginAdmin.vue?vue&type=style&index=0&id=824c9bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824c9bea",
  null
  
)

export default component.exports